export default __webpack_public_path__ + "static/media/brandingImg.4d913496.png";